import type { Draft } from '@/workflow-builder/_contract/draft';
import type { RuntimeState } from '@/workflow-builder/_contract/runtime';

export function isBindingPhase(phase: RuntimeState['phase']): phase is 'binding_inputs' | 'reviewing_input_bindings' {
    return phase === 'binding_inputs' || phase === 'reviewing_input_bindings';
}

type RuntimeStateWithDraftAndBindingPhase = RuntimeState & {
    draft: Draft;
    phase: 'binding_inputs' | 'reviewing_input_bindings';
};

export function hasDraftAndBindingPhase(state: RuntimeState): state is RuntimeStateWithDraftAndBindingPhase {
    return state.draft !== null && isBindingPhase(state.phase);
}

type RuntimeStateWithReviewScope = RuntimeState & {
    draft: Draft;
    activeSlotCursor: NonNullable<RuntimeState['activeSlotCursor']>;
    phase: 'reviewing_input_bindings';
};

export function hasReviewScopeForFinalizeCurrentToolBindings(state: RuntimeState): state is RuntimeStateWithReviewScope {
    return state.draft !== null && state.activeSlotCursor !== null && state.phase === 'reviewing_input_bindings';
}

type RuntimeStateWithDraftAndActiveSlotCursor = RuntimeState & {
    draft: Draft;
    activeSlotCursor: NonNullable<RuntimeState['activeSlotCursor']>;
};

export function hasDraftAndActiveSlotCursor(state: RuntimeState): state is RuntimeStateWithDraftAndActiveSlotCursor {
    return state.draft !== null && state.activeSlotCursor !== null;
}

export function isLoopDraft(draft: Draft): draft is Extract<Draft, { draftKind: 'while' | 'for' }> {
    return draft.draftKind === 'while' || draft.draftKind === 'for';
}

export function isBranchDraft(draft: Draft): draft is Extract<Draft, { draftKind: 'branch' }> {
    return draft.draftKind === 'branch';
}
